import { Image, theme } from '@acorns/web-components'
import styled from 'styled-components'

import { CUSTOM_SMALL_DESKTOP } from '../styled-components'

export const AnchorContainer = styled.a`
  background-color: ${theme.colors.darkOak};
  border-radius: 10px;
  color: ${theme.colors.white};
  display: inline-block;
  margin-top: 10px;
  min-height: 155px;
  padding: 15px 20px 20px;
  position: relative;
  text-decoration: none;
  width: 100%;

  @media (max-width: ${theme.breakpoints.md}px) {
    display: none;
  }
`
export const Title = styled.h5`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  margin: 0;
  padding: 0;
`

export const Subtitle = styled.p`
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`

export const LearnMore = styled.span`
  border-radius: 55px;
  border: 1px solid ${theme.colors.white};
  bottom: 20px;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  left: 20px;
  line-height: 16px;
  padding: 3px 8px;
  position: absolute;

  @media (max-width: ${CUSTOM_SMALL_DESKTOP}px) {
    bottom: initial;
    left: initial;
    margin-bottom: 10px;
    margin-top: 10px;
    position: relative;
  }
`

export const BackgroundImage = styled(Image)`
  bottom: 16px;
  height: 73px;
  position: absolute;
  right: 17px;
  width: 115px;

  @media (max-width: ${CUSTOM_SMALL_DESKTOP}px) {
    bottom: initial;
    float: right;
    position: relative;
    right: initial;
  }
`
